import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Newspaper, Search } from '../../../icons';
import { PageTypes } from '../../../social/constants';
import SideMenuSection from '../../../core/components/SideMenuSection';
import { useNavigation } from '../../../social/providers/NavigationProvider';
import SideMenuActionItem from '../../../core/components/SideMenuActionItem';
export const NewsIcon = styled(Newspaper).attrs({ width: 20, height: 20 }) ``;
export const SearchIcon = styled(Search).attrs({ width: 20, height: 20 }) ``;
const SideSectionCommunity = ({ shouldHideExplore, activePage, children }) => {
    const { onChangePage } = useNavigation();
    return (React.createElement(SideMenuSection, null,
        React.createElement(SideMenuActionItem, { "data-qa-anchor": "side-section-community-side-menu-action-item-news-feed-button", icon: React.createElement(NewsIcon, null), active: activePage === PageTypes.NewsFeed, onClick: () => onChangePage(PageTypes.NewsFeed) },
            React.createElement(FormattedMessage, { id: "sidesectioncommunity.newfeed" })),
        !shouldHideExplore && (React.createElement(SideMenuActionItem, { "data-qa-anchor": "side-section-community-side-menu-action-item-explore-button", icon: React.createElement(SearchIcon, null), active: activePage === PageTypes.Explore, onClick: () => onChangePage(PageTypes.Explore) },
            React.createElement(FormattedMessage, { id: "sidesectioncommunity.explore" }))),
        children));
};
SideSectionCommunity.propTypes = {
    shouldHideExplore: PropTypes.bool,
    children: PropTypes.node,
};
export default SideSectionCommunity;
//# sourceMappingURL=index.js.map